import { Component } from '@angular/core';
import {
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';

@Component({
  selector: 'app-store-filter-dialog',
  templateUrl: './store-filter-dialog.component.html',
  styleUrls: ['./store-filter-dialog.component.scss'],
})
export class StoreFilterDialogComponent {
  constructor(private dialogRef: MatDialogRef<StoreFilterDialogComponent>) {}

  form = new UntypedFormGroup({
    filterName: new UntypedFormControl(null, Validators.required),
  });

  onSaveClick(): void {
    if (this.form.valid) {
      this.dialogRef.close({
        filterName: this.form.controls['filterName'].value,
      });
    }
  }
}
